export default __webpack_public_path__ + "static/media/unit-weight.35a87ecb.svg";